export default "__VITE_ASSET__CQvjaWZ1__"